module.exports = "https://cdn.nebula.starbreeze.com/legal/static/media/brokenRocket.3d3302a9.svg";